import type { AnchorHTMLAttributes } from "react";
import React from "react";

import { cn } from "@/lib/utils";

import {
  getPhoneDetails,
  splitPhoneNumbers,
  type PhoneDetails,
} from "./phoneNumbers";

// eslint-disable-next-line react-refresh/only-export-components
export { getPhoneHref } from "./phoneNumbers";

export const PhoneLink = ({
  value,
  className,
  ...props
}: {
  value: string | null | undefined;
} & Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href">) => {
  const phoneNumbers = splitPhoneNumbers(value)
    .map(getPhoneDetails)
    .filter((phoneNumber): phoneNumber is PhoneDetails => Boolean(phoneNumber));
  if (!phoneNumbers.length) return null;

  return (
    <span className="inline-flex flex-wrap gap-x-2 gap-y-1">
      {phoneNumbers.map((phoneNumber, index) =>
        phoneNumber.href ? (
          <a
            key={`${phoneNumber.href}-${index}`}
            className={cn("underline hover:no-underline", className)}
            href={phoneNumber.href}
            onClick={stopPropagation}
            {...props}
          >
            {phoneNumber.display}
          </a>
        ) : (
          <span key={`${phoneNumber.display}-${index}`} className={className}>
            {phoneNumber.display}
          </span>
        ),
      )}
    </span>
  );
};

const stopPropagation = (e: React.MouseEvent<HTMLAnchorElement>) =>
  e.stopPropagation();
